var map = {
	"./bash": 1760,
	"./java": 1761,
	"./json": 1762,
	"./julia": 1763,
	"./python": 1764,
	"./r": 1765,
	"./rust": 1766,
	"./scala": 1767,
	"./shell": 1768,
	"./sql": 1769,
	"./xml": 1770,
	"./yaml": 1771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1759;